import ChooseIndustry from '../components/Ecommerce/ChooseIndustry';
import '../components/Ecommerce/e-commerce.css'
import Header from "../components/Ecommerce/Header";
import OurIntegration from '../components/Ecommerce/OurIntegration';

import TransitionPage from '../utils/TransitionPage';

import { Helmet } from 'react-helmet-async';

const Ecommerce = () => { 
    return(
        <>
            <Helmet>
                <title>Marketplace & Ecommerce Platforms | Advante Digital</title>
                <meta name="description" content="We maintain and improve marketplaces and ecommerce platforms: storefronts, checkout and payment flows, subscriptions, admin operations, and integrations with AI-assisted engineering and controlled deployment."/>
                <meta name='keywords' content='marketplace platforms, ecommerce, checkout, payments, subscriptions, admin operations, integrations, Shopify, WooCommerce'/>  
            </Helmet>
            <Header />
            <OurIntegration />
            <ChooseIndustry />
            
        </>
    );
}

export default TransitionPage( Ecommerce );